import { createCustomEnum } from "./customEnum";

export type TransactionTypesKeys = "credit" | "debit";

export const TransactionTypes = createCustomEnum({
	Credit: { value: "credit", name: "credit", displayName: "Credit" },
	Debit: { value: "debit", name: "debit", displayName: "Debit" },
});
